<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [cardOptionBtnIcon]="'fa fa-repeat'" [cardOptionBtn]="false" [advanceButton]="true" [title]="'global.overview'|translate" (outputButtonAdvance)="calFunction($event)">
        <app-grid [grid]="grid" ></app-grid>
      </app-card>
    </div>
  </div>
</div>
